// extracted by mini-css-extract-plugin
export default {"container":"ingredientRow_container__oeghp","amountInput":"ingredientRow_amountInput__zDp21","nameInput":"ingredientRow_nameInput__pvTDn","select":"ingredientRow_select__ulzd2"};